<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
<script setup>
defineProps({
  show: { type: Boolean, default: false },
  message: { type: String, default: 'Há mensagens não lidas nesta visita' },
  actionLabel: { type: String, default: 'Abrir conversa' },
});

const emit = defineEmits(['action']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
  <div
    v-show="show"
    class="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md items-center justify-between gap-3 rounded-lais bg-lais-success px-4 py-3 text-white shadow-lais-pop"
  >
    <span class="text-[13px] font-semibold">{{ message }}</span>
    <button
      type="button"
      class="text-[12px] font-bold underline"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>
